/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

// back door for liveSlice purposes

const backdoor = { language: null, priceFormat: null };
export default backdoor;
